(function () {
  function openSpotlightCart() {
    fetch('/?sections=cart-drawer')
      .then(r => r.json())
      .then(function (data) {
        if (data['cart-drawer']) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(data['cart-drawer'], 'text/html');
          var newDrawer = doc.querySelector('cart-drawer');
          var currentDrawer = document.querySelector('cart-drawer');

          if (newDrawer && currentDrawer) {
            // Replace inner content
            currentDrawer.innerHTML = newDrawer.innerHTML;
            // Copy class from freshly fetched drawer (removes is-empty if cart has items)
            currentDrawer.className = newDrawer.className;
          }
        }
        document.querySelector('#cart-icon-bubble')?.click();
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#teeAtcButton, .tee-btn--atc');
    if (!btn) return;

    fetch('/cart.js').then(r => r.json()).then(function (cart) {
      var countBefore = cart.item_count;

      var poll = setInterval(function () {
        fetch('/cart.js').then(r => r.json()).then(function (updated) {
          if (updated.item_count > countBefore) {
            clearInterval(poll);
            openSpotlightCart();
          }
        });
      }, 500);

      setTimeout(function () { clearInterval(poll); }, 8000);
    });
  }, true);
})();